module.exports = __webpack_public_path__ + "static/img/industriesbg5.13c4ab6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industriesbg5.jpg
// module id = l89M
// module chunks = 1